let overlayObserverInstances = [];

function initOverlayObservers() {
    overlayObserverInstances.forEach(observer => {
        if (observer && observer.disconnect) {
            observer.disconnect(); // true = rimuove markup generato
        }
    });

    overlayObserverInstances = []; // resetta l'array


    document.querySelectorAll(".tpd-text-overlay.tpd-text-fade-in").forEach(container => {

        const animationDelayInterval = container.dataset.animationDelayInterval;
        const words = container.querySelectorAll(".word");

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    words.forEach((word, index) => {
                        setTimeout(() => {
                            word.style.opacity = "1";
                        }, index * animationDelayInterval);
                    });
                }
            });
        }, {threshold: 0.3});

        observer.observe(container);
        overlayObserverInstances.push(observer)
    })
}

document.addEventListener("DOMContentLoaded", function () {
    initOverlayObservers();
});


function bindMovements(element, splide) {
    element.addEventListener("click", function (event) {
        const rect = element.getBoundingClientRect();
        const clickX = event.clientX - rect.left;
        const midPoint = rect.width / 2;

        const clickY = event.clientY - rect.top;

        if (clickY > rect.height - 50) {
            return;
        }

        if (clickX > midPoint) {
            splide.go(">");
        } else {
            splide.go("<");
        }
    });
}

let splideInstances = [];

function initSplideSliders() {

    splideInstances.forEach(instance => {
        if (instance && instance.destroy) {
            instance.destroy(true); // true = rimuove markup generato
        }
    });

    splideInstances = []; // resetta l'array


    let elementNodeListOf = document.querySelectorAll('.splide.tpd-hero-carousel');
    if (elementNodeListOf.length > 0) {
        let splide = new Splide('.splide.tpd-hero-carousel').mount();
        splideInstances.push(splide);
        elementNodeListOf.forEach(el => bindMovements(el, splide))
    }

    elementNodeListOf = document.querySelectorAll('.splide-autoscroll');
    if (elementNodeListOf.length > 0) {
        let splide = new Splide('.splide-autoscroll').mount(window.splide.Extensions);
        splideInstances.push(splide);
        elementNodeListOf.forEach(el => bindMovements(el, splide))

    }

    elementNodeListOf = document.querySelectorAll('.splide.tpd-product-gallery');
    if (elementNodeListOf.length > 0) {
        let splide = new Splide('.splide.tpd-product-gallery').mount();
        splideInstances.push(splide);
        elementNodeListOf.forEach(el => bindMovements(el, splide))

    }
}

document.addEventListener("DOMContentLoaded", function () {
    initSplideSliders();
});

function checkOverlap(target, reference, className) {
    const targetRect = target.getBoundingClientRect();
    const referenceRect = reference.getBoundingClientRect();

    const isOverlapping =
        /*  targetRect.top < referenceRect.bottom &&
          targetRect.bottom > referenceRect.top &&
          targetRect.left < referenceRect.right &&
          targetRect.right > referenceRect.left;*/

        targetRect.bottom < referenceRect.bottom &&
        targetRect.bottom > referenceRect.top;

    if (isOverlapping) {
        target.classList.add(className);
    } else {
        target.classList.remove(className);
    }
}

function bindOverlap(target, reference) {
    const targetElement = document.querySelector(target);
    const referenceElement = document.querySelector(reference);

    if (targetElement && referenceElement)
        checkOverlap(targetElement, referenceElement, "tpd-hero-overlapping");

    window.addEventListener("resize", () => {
        const targetElement = document.querySelector(target);
        const referenceElement = document.querySelector(reference);

        if (targetElement && referenceElement)
            checkOverlap(targetElement, referenceElement, "tpd-hero-overlapping");
    });


    window.addEventListener("scroll", () => {
        const targetElement = document.querySelector(target);
        const referenceElement = document.querySelector(reference);

        if (targetElement && referenceElement)
            checkOverlap(targetElement, referenceElement, "tpd-hero-overlapping");
    });
}

document.addEventListener("DOMContentLoaded", () => {
    bindOverlap(".section-header", ".tpd-hero-section");
    bindOverlap(".section-header", ".tpd-product-gallery");
});


document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("a.mega-menu__link[tpd-mega-menu-item]").forEach(link => {

        const menuContent = link.closest(".mega-menu__content");
        const imageLinkBox = menuContent.querySelector("a.tpd-mega-menu-image");
        const img = imageLinkBox.querySelector("img");
        const span = imageLinkBox.querySelector("span");


        link.addEventListener("mouseenter", function () {
            imageLinkBox.href = this.getAttribute("data-img-href");
            img.src = this.getAttribute("data-img-src") || imageLinkBox.getAttribute("data-default-src");
            img.alt = this.getAttribute("data-img-text") || "";
            span.innerHTML = this.getAttribute("data-img-text") || "";
        });

        link.addEventListener("mouseleave", function () {
            imageLinkBox.href = imageLinkBox.getAttribute("data-default-href") || imageLinkBox.href;
            img.src = imageLinkBox.getAttribute("data-default-src") || img.src;
            img.alt = imageLinkBox.getAttribute("data-default-text") || img.alt;
            span.innerHTML = imageLinkBox.getAttribute("data-default-text") || span.innerHTML;
        });
    });

});


document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.gradient-bg .interactive').forEach(interBubble => {
        let curX = 0;
        let curY = 0;
        let tgX = 0;
        let tgY = 0;

        function move() {
            curX += (tgX - curX) / 20;
            curY += (tgY - curY) / 20;
            interBubble.style.transform = `translate(${Math.round(curX)}px, ${Math.round(curY)}px)`;
            requestAnimationFrame(() => {
                move();
            });
        }

        window.addEventListener('mousemove', (event) => {
            tgX = event.clientX;
            tgY = event.clientY;
        });

        move();
    })
});

window.addEventListener("resize", () => {
    document.querySelectorAll("sticky-header")
        .forEach(el => {
            el.removeAttribute("opened");
            el.querySelectorAll("details")
                .forEach(d => d.removeAttribute("open"))
        })
});

document.addEventListener("DOMContentLoaded", function () {

    document.querySelectorAll('.tpd-menu-drawer-trigger-link').forEach(link => {
        link.addEventListener('click', function (event) {
            event.preventDefault();

            // Risali fino a trovare un parent che contiene un <summary> come figlio
            let el = this.parentElement;
            while (el) {
                const summary = el.querySelector('summary');
                if (summary) {
                    summary.click();
                    return;
                }
                el = el.parentElement;
            }

            console.log('Nessun <summary> trovato nei parent.');
        });
    });


});

function scrollToElementWithOffset(id, offset = 0) {
    const element = document.getElementById(id);
    console.log(id, element)
    if (element) {
        const topPosition = element.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
            top: topPosition,
            behavior: 'smooth'
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {

    function toggleDetailsOpen() {
        const isDesktop = window.matchMedia('(min-width: 750px)').matches;
        document.querySelectorAll('details.opened-on-desktop').forEach(detail => {
            if (isDesktop) {
                detail.setAttribute('open', '');
            } else {
                detail.removeAttribute('open');
            }
        });
    }

// Esegui al caricamento della pagina
    toggleDetailsOpen();

// Aggiungi un listener per gestire i cambiamenti di dimensione della finestra
    window.addEventListener('resize', toggleDetailsOpen);


});


document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.tpd-video-controls').forEach(control => {
        const video = control.previousElementSibling;

        if (video && video.tagName.toLowerCase() === 'video') {
            const playBtn = control.querySelector('.togglePlay');
            const stopBtn = control.querySelector('.toggleStop');
            const muteBtn = control.querySelector('.toggleMute');
            const unmuteBtn = control.querySelector('.toggleUnmute');

            playBtn.addEventListener('click', (event) => {
                video.play();
                control.classList.remove('tpd-video-status-stop')
                control.classList.add('tpd-video-status-play')
            });

            stopBtn.addEventListener('click', () => {
                video.pause();
                control.classList.remove('tpd-video-status-play')
                control.classList.add('tpd-video-status-stop')
            });

            muteBtn.addEventListener('click', () => {
                video.muted = false;
                control.classList.remove('tpd-video-status-mute')
                control.classList.add('tpd-video-status-sound')
            });
            unmuteBtn.addEventListener('click', () => {
                video.muted = true;
                control.classList.remove('tpd-video-status-sound')
                control.classList.add('tpd-video-status-mute')
            });
        }
    });


});

